import newold from "../assets/new-imagepart1.png";
import newpart2 from "../assets/new-imagepart2.png";
import patternPart1 from "../assets/patternpart1new.png";
import layer_1 from "../assets/Layer_1.png";
import part2abs from "../assets/part2abstract.png";
import part2abs2 from "../assets/part2abstract2.png";
import launchOffer from "../assets/launchOffer.svg";

const BusinessPage = ({onCTAClick10, onCTAClick499}) => {
  return (
    <div className="w-full flex justify-center bg-[#C6A4FF]">

    <div className="flex flex-col md:grid md:grid-cols-2 gap-8 w-full max-w-screen-xl bg-[#C6A4FF] p-8 pb-28 font-['Montserrat'] mx-auto">
      <div className="text-custom-text mt-10 col-span-2 items-center justify-center text-center">
        <p className="text-xl md:text-3xl font-display lg:text-5xl 2xl:text-6xl mb-2 lg:mb-4 font-semibold">
          AI Readiness & Digital Maturity
        </p>
        <p className="text-xl md:text-3xl font-display lg:text-5xl 2xl:text-6xl pb-8 font-semibold">
          Assessment Index
        </p>
        <button className="bg-white text-[#4B1AB1] px-6 py-2  rounded-full shadow-sm hover:shadow-md transition duration-200 font-semibold text-sm lg:text-lg"
        onClick={onCTAClick499}>
          Get started →
        </button>
      </div>
      <div className="bg-white rounded-2xl overflow-hidden shadow-md">
        <div className="relative">
          <img
            src={layer_1}
            alt="Business"
            className="absolute top-0 left-0 w-full h-3/4 z-0"
          />
          <div className="flex justify-center">
            <div className="bg-[#A776FF] text-[#fff] text-sm px-4 py-2 rounded-b-md font-semibold lg:text-xl">
              For Business
            </div>
          </div>
          <div className="pt-4 text-center relative">
            <p className="text-black text-lg z-10 py-4">
              Assess your organisation’s AI Readiness Today
            </p>
            <img
              src={newold}
              alt="Business"
              className="my-4 rounded relative z-10 w-full"
            />
            <p className="text-2xl font-bold text-black mb-2 relative ">
              $499 USD
            </p>
            <p className="text-md text-gray-600 mb-5 relative">
              Build an AI Ready Organisation
            </p>
            <div className="text-center mb-6 relative">
              <button className="border border-black text-sm px-6 py-2 rounded-full hover:bg-black hover:text-white transition-all"
              onClick={onCTAClick499}
              >
                Get Started →
              </button>
            </div>
          </div>
          <hr className="border-gray-300 mx-auto w-10/12" />
        </div>

        <div className="flex flex-col px-6 md:px-20 md:mx-auto py-8 space-y-12">
          <div className="text-center lg:space-y-7">
            <div className="bg-[#EFEAFF] text-[#6B4EFF] text-xs px-4 py-1 rounded-full inline-block mb-2">
              Part 1
            </div>
            <h2 className="text-[#3B118E] text-xl font-bold lg:text-2xl mb-2">
              Organizational AI Readiness
            </h2>
            <p className="text-gray-600 text-sm mb-4 lg:text-md">
              Complete a self-assessment designed to analyse your organisation’s
              overall readiness for adopting AI technologies across key
              dimensions.
            </p>
            <ul className="text-left text-black text-sm space-y-2 max-w-sm mx-auto">
              <li className="flex items-start gap-2">
                ✅ <span>Instant Executive Report</span>
              </li>
              <li className="flex items-start gap-2">
                ✅ <span>Evaluates preparedness across 15 key areas</span>
              </li>
              <li className="flex items-start gap-2">
                ✅ <span>provides a comprehensive overview</span>
              </li>
            </ul>
          </div>
          <hr className="border-gray-300 mx-auto w-10/12" />
          <div className="text-center lg:space-y-7">
            <div className="bg-[#EFEAFF] text-[#6B4EFF] text-xs px-4 py-1 rounded-full inline-block mb-2">
              Part 2
            </div>
            <h2 className="text-[#3B118E] text-xl font-bold lg:text-2xl mb-2">
              Departmental Digital Maturity
            </h2>
            <p className="text-gray-600 text-sm mb-4 lg:text-md">
              Department heads complete assessment for their department.
              Tailored reports for each department, detailing digital maturity
            </p>
            <ul className="text-left text-black text-sm space-y-2 max-w-sm mx-auto">
              <li className="flex items-start gap-2">
                ✅{" "}
                <span>Focuses on the digital maturity of 8 key functions</span>
              </li>
              <li className="flex items-start gap-2">
                ✅ <span>Identifies function-specific gaps</span>
              </li>
              <li className="flex items-start gap-2">
                ✅{" "}
                <span>highlights areas to enhance digital transformation.</span>
              </li>
            </ul>
          </div>
          <hr className="border-gray-300 mx-auto w-10/12" />
          <div className="text-center lg:space-y-7">
            <div className="bg-[#EFEAFF] text-[#6B4EFF] text-xs px-4 py-1 rounded-full inline-block mb-2">
              Part 3
            </div>
            <h2 className="text-[#3B118E] text-xl font-bold lg:text-2xl mb-2">
              Individual AI Readiness
            </h2>
            <p className="text-gray-600 text-sm mb-4 lg:text-md">
              Once leadership is aligned, invite employees to assess their AI
              literacy.
            </p>
            <ul className="text-left text-black text-sm space-y-2 max-w-sm mx-auto">
              <li className="flex items-start gap-2">
                ✅ <span>Measures employee level AI knowledge</span>
              </li>
              <li className="flex items-start gap-2">
                ✅ <span>Categorizes individuals into Al Learners</span>
              </li>
              <li className="flex items-start gap-2">
                ✅ <span>Drives targeted upskilling and innovation.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="grid grid-row-3 gap-8">
        <div className="row-span-2 bg-white rounded-2xl overflow-hidden shadow-md">
          <div className="relative">
            <img
              src={part2abs}
              alt="Background pattern"
              className="absolute top-0 left-0 w-auto h-1/3 z-0"
            />
            <img
              src={part2abs2}
              alt="Background pattern"
              className="absolute top-0 right-0 w-auto h-1/3 z-0 translate-y-3/4"
            />
            <div className="flex justify-center">
              <div className="bg-[#A776FF] text-white text-sm px-4 py-2 rounded-b-md font-semibold lg:text-xl">
                For Individuals
              </div>
            </div>
            <div className="pt-4 text-center">
              <p className="text-black text-lg z-10 p-4">
                Test your AI Knowledge Now
              </p>
              <img
                src={newpart2}
                alt="Individual"
                className="w-full h-auto rounded my-4 z-10 relative"
              />
              <div className="flex justify-center items-center gap-2 mb-2 relative">
           
                <p className="text-2xl font-bold text-black">
                  
                  $25 USD
                </p>
              </div>
              <p className="text-md text-gray-600 mb-5 relative">
                Curious how much you know&nbsp;&nbsp;about AI
              </p>
              <div className="relative z-10 text-center mb-6">
                <button className="z-10 border border-black text-sm px-6 py-2 rounded-full hover:bg-black hover:text-white transition-all"
                onClick={onCTAClick10}
                >
                  Get Started →
                </button>
              </div>
              <hr className="border-gray-300 mx-auto w-10/12" />
            </div>
            <div className="px-6 py-8 space-y-8 lg:pt-20">
              <h3 className="text-[#3B118E] text-lg font-bold text-center lg:text-2xl mb-2">
                Individual AI Readiness
              </h3>
              <p className="text-xs text-gray-500 text-center mb-6 lg:text-md">
                Curious how much you really know about AI? Know
                <br />
                Your AI Level & Show It Off
              </p>
              <ul className="space-y-3 text-sm text-black max-w-sm mx-auto">
                <li className="flex items-start gap-2">
                  <span>✅</span> Get your AI Score Instantly
                </li>
                <li className="flex items-start gap-2">
                  <span>✅</span> Understand your AI knowledge gaps
                </li>
                <li className="flex items-start gap-2">
                  <span>✅</span> Receive tailored learning suggestions
                </li>
                <li className="flex items-start gap-2">
                  <span>✅</span> Quickly earn a certificate
                </li>
              </ul>
              <p className="text-xs text-center text-gray-600 mt-6">
                “97 million new roles are emerging because of AI.
                <br />
                This is your first step to be future-ready.”
              </p>
            </div>
          </div>
        </div>

        <div className="row-span-1 bg-white rounded-2xl overflow-hidden shadow-md">
          <div className="relative">
            <img
              src={patternPart1}
              alt="Background pattern"
              className="w-full h-auto"
            />
            <div className="absolute bottom-6 right-6 text-right">
              <p className="text-black font-display font-bold text-2xl leading-snug">
                Build an
                <br />
                AI Ready
                <br />
                Organisation
              </p>
            </div>
          </div>
          <div className="px-6 pb-6 pt-2">
            <p className="text-gray-500 text-sm text-right mb-4">
              Once leadership is aligned, invite
              <br />
              employees to assess their AI literacy.
            </p>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default BusinessPage;


